import React, { useEffect, useState } from 'react';
import { taskAPI, projectAPI, userAPI } from '../services/api';
import useAuthStore from '../store/authStore';
import Layout from '../components/Layout';
import './ProjectLeadTasks.css';

const Icon = ({ name, size = 20 }) => {
  const icons = {
    plus: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>,
    search: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>,
    list: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>,
    grid: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg>,
    checkCircle: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" /></svg>,
    clock: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
    user: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    folder: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" /></svg>,
    calendar: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
    x: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
    edit: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
    trash: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
    messageSquare: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>,
    alertCircle: <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>,
  };
  return icons[name] || null;
};

const ProjectLeadTasks = () => {
  const user = useAuthStore((state) => state.user);
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('list');
  const [filters, setFilters] = useState({ status: '', priority: '', type: '', project: '', assignedTo: '', search: '' });
  const [selectedTask, setSelectedTask] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '', description: '', type: '', project: '', assignedTo: '', estimatedHours: '',
    dueDate: '', priority: 'Medium'
  });
  const [comment, setComment] = useState('');

  const taskTypes = ['Feature Development', 'Bug Fix', 'UI Design', 'API Integration', 'Testing Task', 'Deployment Task', 'Documentation Task'];
  const statuses = ['To Do', 'In Progress', 'In Review', 'Blocked', 'Done'];
  const priorities = ['Low', 'Medium', 'High', 'Critical'];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [tasksRes, projectsRes, usersRes] = await Promise.all([
        taskAPI.getAll(),
        projectAPI.getAll(),
        userAPI.getAll()
      ]);

      const allTasks = tasksRes.data?.data || [];
      const allProjects = projectsRes.data?.data || [];
      const allUsers = usersRes.data?.data || [];

      // Projects are already filtered by backend for Project Lead
      const leadProjects = allProjects;

      // Get unique team member IDs from projects
      const teamMemberIds = new Set();
      leadProjects.forEach(project => {
        if (project.teamMembers && Array.isArray(project.teamMembers)) {
          project.teamMembers.forEach(member => {
            const memberId = member._id || member;
            if (memberId) teamMemberIds.add(memberId.toString());
          });
        }
      });

      // Filter tasks from lead projects
      const projectIds = leadProjects.map(p => p._id);
      const leadTasks = allTasks.filter(t => projectIds.includes(t.project?._id));

      // Filter users who are team members in the projects
      const assignableUsers = allUsers.filter(u => teamMemberIds.has(u._id.toString()));

      setTasks(leadTasks);
      setProjects(leadProjects);
      setUsers(assignableUsers);
    } catch (error) {
      console.error('Failed to load data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTask = async (e) => {
    e.preventDefault();
    try {
      await taskAPI.create(formData);
      setShowCreateModal(false);
      resetForm();
      loadData();
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to create task');
    }
  };

  const handleUpdateTask = async (id, updates) => {
    try {
      await taskAPI.update(id, updates);
      loadData();
      if (selectedTask?._id === id) {
        const res = await taskAPI.getById(id);
        setSelectedTask(res.data.data);
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to update task');
    }
  };

  const handleDeleteTask = async (id) => {
    if (!window.confirm('Delete this task?')) return;
    try {
      await taskAPI.delete(id);
      setShowDetailModal(false);
      loadData();
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to delete task');
    }
  };

  const handleAddComment = async () => {
    if (!comment.trim()) return;
    try {
      await taskAPI.addComment(selectedTask._id, { comment });
      setComment('');
      const res = await taskAPI.getById(selectedTask._id);
      setSelectedTask(res.data.data);
    } catch (error) {
      alert('Failed to add comment');
    }
  };

  const openTaskDetail = async (task) => {
    try {
      const res = await taskAPI.getById(task._id);
      setSelectedTask(res.data.data);
      setShowDetailModal(true);
    } catch (error) {
      alert('Failed to load task details');
    }
  };

  const resetForm = () => {
    setFormData({
      title: '', description: '', type: '', project: '', assignedTo: '', estimatedHours: '',
      dueDate: '', priority: 'Medium'
    });
  };

  const filteredTasks = (tasks || []).filter(task => {
    if (filters.search && !task.title?.toLowerCase().includes(filters.search.toLowerCase())) return false;
    if (filters.status && task.status !== filters.status) return false;
    if (filters.priority && task.priority !== filters.priority) return false;
    if (filters.type && task.type !== filters.type) return false;
    if (filters.project && task.project?._id !== filters.project) return false;
    if (filters.assignedTo && task.assignedTo?._id !== filters.assignedTo) return false;
    return true;
  });

  const groupedTasks = {
    'To Do': filteredTasks.filter(t => t.status === 'To Do'),
    'In Progress': filteredTasks.filter(t => t.status === 'In Progress'),
    'In Review': filteredTasks.filter(t => t.status === 'In Review'),
    'Done': filteredTasks.filter(t => t.status === 'Done')
  };

  const getStatusColor = (status) => {
    const colors = {
      'To Do': '#6B7280',
      'In Progress': '#3B82F6',
      'In Review': '#F59E0B',
      'Blocked': '#EF4444',
      'Done': '#10B981'
    };
    return colors[status] || '#6B7280';
  };

  const getPriorityColor = (priority) => {
    const colors = {
      'Low': '#10B981',
      'Medium': '#3B82F6',
      'High': '#F59E0B',
      'Critical': '#EF4444'
    };
    return colors[priority] || '#6B7280';
  };

  return (
    <Layout>
      <div className="lead-tasks-page">
        <div className="lead-tasks-header">
          <div className="header-left">
            <h1 className="page-title">Tasks</h1>
            <p className="page-subtitle">Manage and supervise team tasks</p>
          </div>
          <div className="header-actions">
            <div className="view-toggle">
              <button className={viewMode === 'list' ? 'active' : ''} onClick={() => setViewMode('list')}>
                <Icon name="list" size={18} />
                <span>List</span>
              </button>
              <button className={viewMode === 'kanban' ? 'active' : ''} onClick={() => setViewMode('kanban')}>
                <Icon name="grid" size={18} />
                <span>Kanban</span>
              </button>
            </div>
            <button className="btn-create" onClick={() => setShowCreateModal(true)}>
              <Icon name="plus" size={18} />
              <span>Create Task</span>
            </button>
          </div>
        </div>

        <div className="filters-section">
          <div className="search-box">
            <Icon name="search" size={18} />
            <input
              type="text"
              placeholder="Search tasks..."
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            />
          </div>
          <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
            <option value="">All Status</option>
            {statuses.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
          <select value={filters.priority} onChange={(e) => setFilters({ ...filters, priority: e.target.value })}>
            <option value="">All Priority</option>
            {priorities.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
          <select value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })}>
            <option value="">All Types</option>
            {taskTypes.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <select value={filters.project} onChange={(e) => setFilters({ ...filters, project: e.target.value })}>
            <option value="">All Projects</option>
            {projects.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
          </select>
          <select value={filters.assignedTo} onChange={(e) => setFilters({ ...filters, assignedTo: e.target.value })}>
            <option value="">All Assignees</option>
            {users.map(u => (
              <option key={u._id} value={u._id}>{u.name}</option>
            ))}
          </select>
        </div>

        {loading ? (
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading tasks...</p>
          </div>
        ) : viewMode === 'list' ? (
          <div className="tasks-list-view">
            {filteredTasks.length === 0 ? (
              <div className="empty-state">
                <Icon name="checkCircle" size={48} />
                <p>No tasks found</p>
              </div>
            ) : (
              filteredTasks.map(task => (
                <div key={task._id} className="task-card" onClick={() => openTaskDetail(task)}>
                  <div className="task-card-header">
                    <h3 className="task-title">{task.title}</h3>
                    <div className="task-badges">
                      <span className="status-badge" style={{ backgroundColor: `${getStatusColor(task.status)}20`, color: getStatusColor(task.status) }}>
                        {task.status}
                      </span>
                      <span className="priority-badge" style={{ backgroundColor: `${getPriorityColor(task.priority)}20`, color: getPriorityColor(task.priority) }}>
                        {task.priority}
                      </span>
                    </div>
                  </div>
                  <p className="task-description">{task.description}</p>
                  <div className="task-meta">
                    <span className="meta-item">
                      <Icon name="folder" size={14} />
                      {task.project?.name}
                    </span>
                    <span className="meta-item">
                      <Icon name="user" size={14} />
                      {task.assignedTo?.name}
                    </span>
                    <span className="meta-item">
                      <Icon name="clock" size={14} />
                      {task.estimatedHours}h
                    </span>
                    {task.dueDate && (
                      <span className="meta-item">
                        <Icon name="calendar" size={14} />
                        {new Date(task.dueDate).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                  <div className="task-type-badge">{task.type}</div>
                </div>
              ))
            )}
          </div>
        ) : (
          <div className="kanban-view">
            {Object.entries(groupedTasks).map(([status, statusTasks]) => (
              <div key={status} className="kanban-column">
                <div className="column-header">
                  <h3>{status}</h3>
                  <span className="task-count">{statusTasks.length}</span>
                </div>
                <div className="column-content">
                  {statusTasks.map(task => (
                    <div key={task._id} className="kanban-card" onClick={() => openTaskDetail(task)}>
                      <h4>{task.title}</h4>
                      <p>{task.description}</p>
                      <div className="kanban-meta">
                        <span className="priority-dot" style={{ backgroundColor: getPriorityColor(task.priority) }}></span>
                        <span>{task.assignedTo?.name}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {showCreateModal && (
          <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Create New Task</h2>
                <button className="btn-icon" onClick={() => setShowCreateModal(false)}>
                  <Icon name="x" size={20} />
                </button>
              </div>
              <form onSubmit={handleCreateTask} className="modal-body">
                <div className="form-group">
                  <label>Title *</label>
                  <input type="text" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} required />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Type *</label>
                    <select value={formData.type} onChange={(e) => setFormData({ ...formData, type: e.target.value })} required>
                      <option value="">Select Type</option>
                      {taskTypes.map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Priority</label>
                    <select value={formData.priority} onChange={(e) => setFormData({ ...formData, priority: e.target.value })}>
                      {priorities.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Project *</label>
                    <select value={formData.project} onChange={(e) => setFormData({ ...formData, project: e.target.value })} required>
                      <option value="">Select Project</option>
                      {projects?.length > 0 ? (
                        projects.map(p => <option key={p._id} value={p._id}>{p.name}</option>)
                      ) : (
                        <option disabled>No projects available</option>
                      )}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Assign To *</label>
                    <select value={formData.assignedTo} onChange={(e) => setFormData({ ...formData, assignedTo: e.target.value })} required>
                      <option value="">Select User</option>
                      {(users || []).length > 0 ? (
                        users.map(u => (
                          <option key={u._id} value={u._id}>{u.name} ({u.role})</option>
                        ))
                      ) : (
                        <option disabled>No users available</option>
                      )}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} rows="3" />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Estimated Hours *</label>
                    <input type="number" value={formData.estimatedHours} onChange={(e) => setFormData({ ...formData, estimatedHours: e.target.value })} required />
                  </div>
                  <div className="form-group">
                    <label>Due Date</label>
                    <input type="date" value={formData.dueDate} onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })} />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn-secondary" onClick={() => setShowCreateModal(false)}>Cancel</button>
                  <button type="submit" className="btn-primary">Create Task</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {showDetailModal && selectedTask && (
          <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
            <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>{selectedTask.title}</h2>
                <button className="btn-icon" onClick={() => setShowDetailModal(false)}>
                  <Icon name="x" size={20} />
                </button>
              </div>
              <div className="modal-body">
                <div className="detail-header">
                  <div className="detail-badges">
                    <span className="status-badge" style={{ backgroundColor: `${getStatusColor(selectedTask.status)}20`, color: getStatusColor(selectedTask.status) }}>
                      {selectedTask.status}
                    </span>
                    <span className="priority-badge" style={{ backgroundColor: `${getPriorityColor(selectedTask.priority)}20`, color: getPriorityColor(selectedTask.priority) }}>
                      {selectedTask.priority}
                    </span>
                    <span className="type-badge">{selectedTask.type}</span>
                  </div>
                  <div className="detail-actions">
                    <select value={selectedTask.status} onChange={(e) => handleUpdateTask(selectedTask._id, { status: e.target.value })}>
                      {statuses.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                    <button className="btn-icon btn-danger" onClick={() => handleDeleteTask(selectedTask._id)}>
                      <Icon name="trash" size={18} />
                    </button>
                  </div>
                </div>
                <p className="detail-description">{selectedTask.description}</p>
                <div className="detail-grid">
                  <div className="detail-item">
                    <Icon name="folder" size={16} />
                    <span><strong>Project:</strong> {selectedTask.project?.name}</span>
                  </div>
                  <div className="detail-item">
                    <Icon name="user" size={16} />
                    <span><strong>Assigned To:</strong> {selectedTask.assignedTo?.name}</span>
                  </div>
                  <div className="detail-item">
                    <Icon name="clock" size={16} />
                    <span><strong>Estimated:</strong> {selectedTask.estimatedHours}h</span>
                  </div>
                  {selectedTask.dueDate && (
                    <div className="detail-item">
                      <Icon name="calendar" size={16} />
                      <span><strong>Due Date:</strong> {new Date(selectedTask.dueDate).toLocaleDateString()}</span>
                    </div>
                  )}
                </div>
                <div className="comments-section">
                  <h3>
                    <Icon name="messageSquare" size={18} />
                    Comments ({selectedTask.comments?.length || 0})
                  </h3>
                  <div className="comments-list">
                    {selectedTask.comments?.map((c, i) => (
                      <div key={i} className="comment-item">
                        <div className="comment-header">
                          <strong>{c.user?.name}</strong>
                          <span>{new Date(c.createdAt).toLocaleString()}</span>
                        </div>
                        <p>{c.comment}</p>
                      </div>
                    ))}
                  </div>
                  <div className="comment-input">
                    <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Add a comment..." rows="2" />
                    <button onClick={handleAddComment} className="btn-primary">Add Comment</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ProjectLeadTasks;
